import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ArticleSection } from './components/ArticleSection';
import { ProductCard } from './components/ProductCard';
import { ComparisonTable } from './components/ComparisonTable';
import { FinalVerdict } from './components/FinalVerdict';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <main className="max-w-4xl mx-auto px-4 py-12" data-id="element-3">
        <ArticleSection data-id="element-4" />
        <ProductCard data-id="element-5" />
        <ComparisonTable data-id="element-6" />
        <FinalVerdict data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}